/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Create_Aria_LabelInputs */

const en_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new style guide`)
};

const fr_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un nouveau guide de style`)
};

const de_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Styleguide erstellen`)
};

const it_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una nuova guida di stile`)
};

const ru_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новое руководство по стилю`)
};

const es_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una nueva guía de estilo`)
};

const zh_cn2_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新的风格指南`)
};

const ja_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいスタイルガイドを作成する`)
};

const hi_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई स्टाइल गाइड बनाएं`)
};

const pt_pt2_style_guide_manager_create_aria_label = /** @type {(inputs: Style_Guide_Manager_Create_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo guia de estilo`)
};

/**
* | output |
* | --- |
* | "Create new style guide" |
*
* @param {Style_Guide_Manager_Create_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_create_aria_label = /** @type {((inputs?: Style_Guide_Manager_Create_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Create_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_create_aria_label(inputs)
	if (locale === "de") return de_style_guide_manager_create_aria_label(inputs)
	if (locale === "it") return it_style_guide_manager_create_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_create_aria_label(inputs)
	if (locale === "es") return es_style_guide_manager_create_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_create_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_create_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_create_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_create_aria_label(inputs)
	return en_style_guide_manager_create_aria_label(inputs)
});